<template>
  <div class="card">
    <div class="bg-blue-light px-1 rounded pb-2">
      <TitleButton
          class="mt-1"
          btnTitle="List"
          :showBtn="true"
          :showAddNew="false"
          :title="headerTitle"
          @onClickCloseButton="navigateToListPage"
      />
    </div>
    <div class="px-2 mt-1">
      <div class="card">
        <div class="card-body">
          <ul class="nav nav-tabs" id="myTab" role="tablist">
            <li class="nav-item active">
              <a class="nav-link active" id="req-info-tab-fill" data-bs-toggle="tab" href="#req-info-tab" role="tab" aria-controls="req-info-tab" aria-selected="false">Requisition Information</a>
            </li>
            <li class="nav-item active">
              <a class="nav-link" id="job-detailsfill" data-bs-toggle="tab" href="#job-details-tab" role="tab" aria-controls="job-details-tab" aria-selected="false">Job Details</a>
            </li>
          </ul>
          <hr>

          <div class="tab-content">
            <div class="tab-pane show active" id="req-info-tab" role="tabpanel" aria-labelledby="req-info-tab-fill">
              <div class="row">
                <div class="col-12 col-sm-6 col-md-4 col-lg-4">
                  <label class="form-label">Requisition Title</label>
                  <input
                      class="form-control invoice-edit-input"
                      tabindex="1"
                      type="text"
                      placeholder=""
                      :disabled="isApproval"
                      v-model="formData.title"
                  >
                </div>

                <div class="col-12 col-sm-6 col-md-4 col-lg-4">
                  <label class="align-middle">Designation</label>
                  <v-select
                      placeholder="Select Designation"
                      v-model="formData.designation_id"
                      :options="designationList"
                      :disabled="isApproval"
                      label="name"
                      :reduce="name => name.id"
                  />
                </div>

                <div class="col-12 col-sm-6 col-md-4 col-lg-4">
                  <label class="align-middle">Employee Category</label>
                  <v-select
                      placeholder="Select Category"
                      v-model="formData.employee_category_id"
                      :options="employeeCategoryList"
                      :disabled="isApproval"
                      label="name"
                      :reduce="name => name.id"
                  />
                </div>

                <div class="col-12 col-sm-6 col-md-4 col-lg-4">
                  <label class="align-middle">Department</label>
                  <v-select
                      placeholder="Select Department"
                      v-model="formData.department_id"
                      :options="departmentList"
                      :disabled="isApproval"
                      label="name"
                      :reduce="name => name.id"
                  />
                </div>

                <div class="col-12 col-sm-6 col-md-4 col-lg-4">
                <label class="form-label">Job Location</label>
                  <AsyncSelect
                      placeholder="Select Job Location"
                      v-model="area"
                      :api-service="fetchAreaList"
                      :disabled="isApproval"
                      label="name"
                  />
                </div>

                <div class="col-12 col-sm-6 col-md-4 col-lg-4">
                  <label class="form-label">No Of Vacancy</label>
                  <input
                      class="form-control invoice-edit-input"
                      tabindex="1"
                      type="text"
                      placeholder=""
                      :disabled="isApproval"
                      v-model="formData.no_of_vacancy"
                  >
                </div>
                </div>
            </div>

            <div class="tab-pane" id="job-details-tab" role="tabpanel" aria-labelledby="job-details-tab-fill">
              <div class="row">
              <div class="col-12 col-sm-6 col-md-4 col-lg-4">
                <label class="form-label">Key Responsibilities</label>
                <TipTapEditor ref="keyResponsibilityEditor" :content="keyResponsibility" />
              </div>
              <div class="col-12 col-sm-6 col-md-4 col-lg-4">
                <label class="form-label">Required Qualifications</label>
                <TipTapEditor ref="requiredQualificationsEditor" :content="requiredQualifications" />
              </div>
              <div class="col-12 col-sm-6 col-md-4 col-lg-4">
                <label class="form-label">Preferred Skills & Expertise</label>
                <TipTapEditor ref="preferredSkillsEditor" :content="preferredSkills"/>
              </div>

              <div class="col-12 col-sm-6 col-md-4 col-lg-4">
                <label class="form-label">Experience Required From (in Years)</label>
                <input
                    class="form-control invoice-edit-input"
                    tabindex="1"
                    type="number"
                    placeholder=""
                    :disabled="isApproval"
                    v-model="formData.experience_required_from"
                >
              </div>

              <div class="col-12 col-sm-6 col-md-4 col-lg-4">
                <label class="form-label">Experience Required To (in Years)</label>
                <input
                    class="form-control invoice-edit-input"
                    tabindex="1"
                    type="number"
                    placeholder=""
                    :disabled="isApproval"
                    v-model="formData.experience_required_to"
                >
              </div>

              <div class="col-12 col-sm-6 col-md-4 col-lg-4">
                  <label class="form-label">Experience Remarks</label>
                  <input
                      class="form-control invoice-edit-input"
                      tabindex="1"
                      type="text"
                      :disabled="isApproval"
                      placeholder=""
                      v-model="formData.experience_remarks"
                  >
                </div>

                <div class="col-12 col-sm-6 col-md-4 col-lg-4">
                  <label class="form-label">Age Limit From (in Years)</label>
                  <input
                      class="form-control invoice-edit-input"
                      tabindex="1"
                      type="number"
                      placeholder=""
                      :disabled="isApproval"
                      v-model="formData.age_limit_from"
                  >
                </div>

                <div class="col-12 col-sm-6 col-md-4 col-lg-4">
                  <label class="form-label">Age Limit To (in Years)</label>
                  <input
                      class="form-control invoice-edit-input"
                      tabindex="1"
                      type="number"
                      placeholder=""
                      :disabled="isApproval"
                      v-model="formData.age_limit_to"
                  >
                </div>

                <div class="col-12 col-sm-6 col-md-4 col-lg-4">
                  <label class="form-label">Age Remarks</label>
                  <input
                      class="form-control invoice-edit-input"
                      tabindex="1"
                      type="text"
                      :disabled="isApproval"
                      placeholder=""
                      v-model="formData.age_remarks"
                  >
                </div>

                <div class="col-12 col-sm-6 col-md-4 col-lg-4">
                  <label class="form-label">Salary Range(From)</label>
                  <input
                      class="form-control invoice-edit-input"
                      tabindex="1"
                      type="number"
                      step="any"
                      :disabled="isApproval"
                      placeholder=""
                      v-model="formData.salary_from"
                  >
                </div>

                <div class="col-12 col-sm-6 col-md-4 col-lg-4">
                  <label class="form-label">Salary Range(To)</label>
                  <input
                      class="form-control invoice-edit-input"
                      tabindex="1"
                      type="number"
                      step="any"
                      :disabled="isApproval"
                      placeholder=""
                      v-model="formData.salary_to"
                  >
                </div>

                <div class="col-12 col-sm-6 col-md-4 col-lg-4">
                  <label class="form-label">Salary Remarks</label>
                  <input
                      class="form-control invoice-edit-input"
                      tabindex="1"
                      type="text"
                      step="any"
                      :disabled="isApproval"
                      placeholder=""
                      v-model="formData.salary_remarks"
                  >
                </div>

                <div class="col-12 col-sm-6 col-md-4 col-lg-4">
                  <label class="form-label">Salary Grade</label>
                  <v-select
                      placeholder="Select Salary Grade Scale"
                      v-model="formData.salary_grade_serial"
                      :options="salaryGradeData"
                      :reduce="name => name.grade_serial"
                      :disabled="isApproval"
                      label="grade_number"
                  />
                </div>

                <div class="col-12 col-sm-6 col-md-4 col-lg-4">
                  <label class="form-label">Gender</label>
                  <select :disabled="isApproval" class="form-control" id="gender" v-model="formData.gender">
                    <option value=''>Select Gender</option>
                    <option v-for="(gender, key) in genders" :value="key">{{ gender }}</option>
                  </select>
                </div>

                <div class="col-12 col-sm-6 col-md-4 col-lg-4">
                  <label class="form-label">Application Deadline</label>
                  <input
                      class="form-control invoice-edit-input"
                      tabindex="1"
                      type="date"
                      :disabled="isApproval"
                      v-model="formData.application_deadline"
                  >
                </div>

                <div class="col-12 col-sm-6 col-md-4 col-lg-4">
                  <label class="form-label">General Note</label>
                  <TipTapEditor ref="generalNoteEditor" :content="generalNotes"/>
                </div>

              </div>
            </div>

            <div v-if="isApproval" class="col-12 pt-2">
              <label for="">Approval Remarks</label>
              <textarea v-model="remarks" class="form-control"></textarea>
            </div>

          </div>
        </div>
      </div>
    </div>


    <div class="mt-2 d-flex justify-content-start justify-content-sm-center px-2 gap-1 flex-wrap pb-2">
      <hr class="hr-full-width mb-1">

      <span  v-if="(!isApproval && !['approved', 'hold', 'reject'].includes(jobRequisitionEditData.status)) || isJobPost">
        <button :disabled="saveButtonLoader || saveNewButtonLoader" @click="saveAP()"
                class="btn btn-primary me-1">
          Save
        </button>
        <button :disabled="saveButtonLoader || saveNewButtonLoader" @click="saveAP(false)"
                class="btn btn-primary">Save & New
        </button>
      </span>

      <span v-if="isJobPost && isJobPublish">
        <button :disabled="saveButtonLoader || saveNewButtonLoader" @click="updateJobPublish('publish')"
                class="btn btn-primary me-1">
           Post Job
        </button>
      </span>

      <span v-if="isApproval && !['approved', 'hold', 'reject'].includes(jobRequisitionEditData.status)">
         <button :disabled="saveButtonLoader || saveNewButtonLoader" @click="updateStatus('approved')"
                 class="btn btn-success me-1">Approved
        </button>
        <button :disabled="saveButtonLoader || saveNewButtonLoader" @click="updateStatus('hold')"
                class="btn btn-warning me-1">Hold
        </button>
        <button :disabled="saveButtonLoader || saveNewButtonLoader" @click="updateStatus('reject')"
                class="btn btn-danger me-1">Reject
        </button>
        <button :disabled="saveButtonLoader || saveNewButtonLoader" @click="updateStatus('return')"
                class="btn btn-primary me-1">Return
        </button>
      </span>


      <button @click="navigateToListPage" class="btn btn-outline-secondary">Cancel</button>
    </div>

    <GlobalLoader/>
  </div>
</template>
<script setup>
import {computed, inject, onMounted, ref} from 'vue'
import {useRoute, useRouter} from "vue-router";
import TitleButton from '@/components/atom/TitleButton'
import handleHrPayroll from "@/services/modules/hrPayroll/hrPayroll";
import GlobalLoader from "@/components/atom/GlobalLoader.vue";
import {useStore} from "vuex";
import handleDepartments from "@/services/modules/procurement/organization-settings/department";
import handleDesignation from "@/services/modules/procurement/organization-settings/designation";
import handleHospital from '@/services/modules/hospital'
import handleCrm from '@/services/modules/crm/crm'
import AsyncSelect from "@/components/molecule/input-field/AsyncSelect.vue";
import handleChartAccount from '@/services/modules/chartAccount'
import TipTapEditor from '@/components/atom/TipTapEditor'

const store = useStore();
const router = useRouter()
const route = useRoute()
const showError = inject('showError');
const showSuccess = inject('showSuccess')
const companyId = computed(() => {
  return route.params.companyId
})

let loader =ref(false)
let remarks =ref('')
let saveButtonLoader = ref(false)
let keyResponsibility = ref('')
let keyResponsibilityEditor = ref('')
let requiredQualifications = ref('')
let requiredQualificationsEditor = ref('')
let preferredSkills = ref('')
let preferredSkillsEditor = ref('')
let generalNoteEditor = ref('')
let generalNotes = ref('')
let saveNewButtonLoader = ref(false)
let isCreate = ref(true)
let isApproval = ref(false)
let isJobPost = ref(false)
let isJobPublish = ref(false)
let headerTitle = ref("Add Job Requisition")
let jobRequisitionEditData = ref({})
let departmentList = ref([])
const area = ref(null);
const status = ref([]);
const designationList = ref([]);
let employeeCategoryList = ref([])
let genders = ref([])
let salaryGradeData = ref([])

let jobRequisitionData = {}
let formData = ref({
  company_id: companyId,
  designation_id:'',
  employee_category_id:'',
  area_id:'',
  department_id:'',
  salary_grade_serial:'',
  title:'',
  no_of_vacancy:'',
  key_responsibility:'',
  required_qualification:'',
  skills:'',
  gender:'',
  experience_required_from:'',
  experience_required_to:'',
  experience_remarks:'',
  age_limit_from:'',
  age_limit_to:'',
  age_remarks:'',
  salary_from:'',
  salary_to:'',
  salary_remarks:'',
  application_deadline:'',
  status: 'pending',
  publish_status: 'pending',
  type: 'requisition',
})

function navigateToListPage() {
  delete route.query.jobRequisitionId;
  delete route.query.is_approval;
  delete route.query.is_job_post;
  let name = 'job-requisition';
  if (isJobPost.value) {
    name = 'job-posting';
  } else if (isApproval.value) {
    name = 'job-approval';
  }
  router.push({name: name, params: route.params, query: route.query});
}
const { fetchDepartmentList } = handleDepartments()
const { fetchDesignationList } = handleDesignation()
const { fetchAreaList } = handleCrm();
const { fetchNoteMasterList } = handleHospital()
const { fetchHome } = handleChartAccount()

const {
  fetchSingleJobRequisition,
  updateJobRequisition,
  fetchSalaryGradeScale,
  createJobRequisition,
  jobRequisitionApproval,
  jobRequisitionPublish
} = handleHrPayroll()

function saveAP(redirect = true) {
  loader.value = true
  saveButtonLoader.value = true
  if (isCreate.value) {
    handleSubmit(redirect);
  } else {
    handleUpdate(redirect);
  }
}

function updateStatus(status) {
  loader.value = true
  saveButtonLoader.value = true

  let approvalData = {};
  approvalData.id = formData.value.id;
  approvalData.company_id  = formData.value.company_id;
  approvalData.status  = status;
  approvalData.remarks  = remarks.value;

  jobRequisitionApproval(approvalData, getQuery())
      .then(res => {
        if (!res.status) {
          showError(res.message)
          return
        }
        showSuccess(res.message)
        navigateToListPage()
      })
      .catch(err => {
        console.log(err)
      }).finally(() => {
      loader.value = false
      saveButtonLoader.value = false
  })
}

function updateJobPublish(publishStatus) {
  loader.value = true
  saveButtonLoader.value = true

  let approvalData = {};
  approvalData.id = formData.value.id;
  approvalData.company_id  = formData.value.company_id;
  approvalData.publish_status  = publishStatus;

  jobRequisitionPublish(approvalData, getQuery())
      .then(res => {
        if (!res.status) {
          showError(res.message)
          return
        }
        showSuccess(res.message)
        navigateToListPage()
      })
      .catch(err => {
        console.log(err)
      }).finally(() => {
      loader.value = false
      saveButtonLoader.value = false
  })
}

const getDesignationList = async () => {
  let query = getQuery();
  designationList.value = []

  await fetchDesignationList(query).then(res => {
    if (!res.status){
      designationList.value = []
      return
    }
    designationList.value = res.data;
  }).catch(err => {
    console.log(err)
  })
}

function handleSubmit(redirect) {
  jobRequisitionData.company_id  = formData.value.company_id;
  jobRequisitionData.status = isJobPost.value ? 'approved' : formData.value.publish_status;
  jobRequisitionData.publish_status = formData.value.publish_status;
  jobRequisitionData.type = isJobPost.value ? 'posting' : formData.value.type;
  jobRequisitionData.title = formData.value.title;
  jobRequisitionData.designation_id = formData.value.designation_id;
  jobRequisitionData.employee_category_id = formData.value.employee_category_id;
  jobRequisitionData.department_id = formData.value.department_id;
  jobRequisitionData.area_id = area.value ? area.value.id : null;
  jobRequisitionData.no_of_vacancy = formData.value.no_of_vacancy;
  jobRequisitionData.key_responsibility = keyResponsibilityEditor.value ? keyResponsibilityEditor.value.getHTML() : '';
  jobRequisitionData.required_qualification = requiredQualificationsEditor.value ? requiredQualificationsEditor.value.getHTML() : '';
  jobRequisitionData.skills = preferredSkillsEditor.value ? preferredSkillsEditor.value.getHTML() : '';
  jobRequisitionData.general_note = generalNoteEditor.value ? generalNoteEditor.value.getHTML() : '';
  jobRequisitionData.experience_required_from = formData.value.experience_required_from;
  jobRequisitionData.experience_required_to = formData.value.experience_required_to;
  jobRequisitionData.experience_remarks = formData.value.experience_remarks;
  jobRequisitionData.gender = formData.value.gender;
  jobRequisitionData.age_limit_from = formData.value.age_limit_from;
  jobRequisitionData.age_limit_to = formData.value.age_limit_to;
  jobRequisitionData.age_remarks = formData.value.age_remarks;
  jobRequisitionData.salary_grade_serial = formData.value.salary_grade_serial;
  jobRequisitionData.salary_from = formData.value.salary_from;
  jobRequisitionData.salary_to = formData.value.salary_to;
  jobRequisitionData.salary_remarks = formData.value.salary_remarks;
  jobRequisitionData.application_deadline = formData.value.application_deadline;
  createAP(redirect);
}

function handleUpdate(redirect) {
  jobRequisitionData.id = formData.value.id;
  jobRequisitionData.company_id  = formData.value.company_id;
  jobRequisitionData.status = formData.value.status;
  jobRequisitionData.publish_status = formData.value.publish_status;
  jobRequisitionData.type = formData.value.type;
  jobRequisitionData.title = formData.value.title;
  jobRequisitionData.designation_id = formData.value.designation_id;
  jobRequisitionData.employee_category_id = formData.value.employee_category_id;
  jobRequisitionData.department_id = formData.value.department_id;
  jobRequisitionData.area_id = area.value ? area.value.id : null;
  jobRequisitionData.no_of_vacancy = formData.value.no_of_vacancy;
  jobRequisitionData.key_responsibility = keyResponsibilityEditor.value ? keyResponsibilityEditor.value.getHTML() : '';
  jobRequisitionData.required_qualification = requiredQualificationsEditor.value ? requiredQualificationsEditor.value.getHTML() : '';
  jobRequisitionData.skills = preferredSkillsEditor.value ? preferredSkillsEditor.value.getHTML() : '';
  jobRequisitionData.general_note = generalNoteEditor.value ? generalNoteEditor.value.getHTML() : '';
  jobRequisitionData.experience_required_from = formData.value.experience_required_from;
  jobRequisitionData.experience_required_to = formData.value.experience_required_to;
  jobRequisitionData.experience_remarks = formData.value.experience_remarks;
  jobRequisitionData.gender = formData.value.gender;
  jobRequisitionData.age_limit_from = formData.value.age_limit_from;
  jobRequisitionData.age_limit_to = formData.value.age_limit_to;
  jobRequisitionData.age_remarks = formData.value.age_remarks;
  jobRequisitionData.salary_grade_serial = formData.value.salary_grade_serial;
  jobRequisitionData.salary_from = formData.value.salary_from;
  jobRequisitionData.salary_to = formData.value.salary_to;
  jobRequisitionData.salary_remarks = formData.value.salary_remarks;
  jobRequisitionData.application_deadline = formData.value.application_deadline;
  updateAPData(redirect);
}

function createAP(redirect = true) {
  createJobRequisition(jobRequisitionData, getQuery())
      .then(res => {
        if (!res.status) {
          showError(res.message)
          return
        }
        showSuccess(res.message)
        if (redirect) navigateToListPage()

      })
      .catch(err => {
        console.log(err)
      }).finally(() => {
        loader.value = false
        saveButtonLoader.value = false
      })
}

function updateAPData(redirect = true) {
  updateJobRequisition(jobRequisitionData, jobRequisitionData.id, getQuery())
      .then(res => {
        if (!res.status) {
          showError(res.message)
          return
        }
         showSuccess(res.message);
         if (redirect) navigateToListPage()

      })
      .catch(err => {
        console.log(err)
      }).finally(() => {
        loader.value = false
        saveButtonLoader.value = false
      })
}

function getQuery() {
  return `?company_id=${route.params.companyId}`;
}

function setFormData() {
  if (isApproval.value){
    headerTitle.value = "Job Requisition Approval";
  }else if(isJobPost.value){
    headerTitle.value = "Update Job Post";
  }else{
    headerTitle.value = "Update Job Requisition";
  }
  formData.value.id =  jobRequisitionEditData.value.id;
  formData.value.title = jobRequisitionEditData.value.title;
  formData.value.designation_id = jobRequisitionEditData.value.designation_id;
  formData.value.employee_category_id = jobRequisitionEditData.value.employee_category_id;
  formData.value.department_id = jobRequisitionEditData.value.department_id;
  formData.value.no_of_vacancy = jobRequisitionEditData.value.no_of_vacancy;
  keyResponsibility.value = jobRequisitionEditData.value.key_responsibility;
  requiredQualifications.value = jobRequisitionEditData.value.required_qualification;
  preferredSkills.value = jobRequisitionEditData.value.skills;
  generalNotes.value = jobRequisitionEditData.value.general_note;
  formData.value.experience_required_from = jobRequisitionEditData.value.experience_required_from;
  formData.value.experience_required_to = jobRequisitionEditData.value.experience_required_to;
  formData.value.experience_remarks = jobRequisitionEditData.value.experience_remarks;
  formData.value.gender = jobRequisitionEditData.value.gender;
  formData.value.age_limit_from = jobRequisitionEditData.value.age_limit_from;
  formData.value.age_limit_to = jobRequisitionEditData.value.age_limit_to;
  formData.value.age_remarks = jobRequisitionEditData.value.age_remarks;
  formData.value.salary_grade_serial = jobRequisitionEditData.value.salary_grade_serial;
  formData.value.salary_from = jobRequisitionEditData.value.salary_from;
  formData.value.salary_to = jobRequisitionEditData.value.salary_to;
  formData.value.salary_remarks = jobRequisitionEditData.value.salary_remarks;
  formData.value.application_deadline = jobRequisitionEditData.value.application_deadline;
  formData.value.status = jobRequisitionEditData.value.status;
  formData.value.publish_status = jobRequisitionEditData.value.publish_status;
  formData.value.type = jobRequisitionEditData.value.type;

  area.value = {
    id: jobRequisitionEditData.value.area_id,
    name: jobRequisitionEditData.value.area_name
  }
}

const getDepartmentList = async () => {
  let query = getQuery();
  departmentList.value = []

  await fetchDepartmentList(query).then(res => {
    if (!res.status){
      departmentList.value = []
      return
    }
    departmentList.value = res.data;
  }).catch(err => {
    console.log(err)
  })
}

const getEmployeeCategoryList = async () => {
  let query = getQuery();
  query += '&is_all=true&status=active&note_type=employee_category'
  employeeCategoryList.value = []

  await fetchNoteMasterList(query).then(res => {
    if (!res.status){
      employeeCategoryList.value = []
      return
    }
    employeeCategoryList.value = res.data;
  }).catch(err => {
    console.log(err)
  })
}

const getSalaryGrade = async () => {
  const query = getQuery();
  salaryGradeData.value = []

  await fetchSalaryGradeScale(query).then(res => {
    if (!res.status){
      return
    }
    salaryGradeData.value = res.data.data;
  }).catch(err => {
    console.log(err)
  })
}

function onPageReload() {
  loader.value=true
  Promise.all([
    fetchHome().then(res => {
      if (res.data) {
        genders.value = res.data.genders
      }
    }),
    getDepartmentList(),
    getDesignationList(),
    getEmployeeCategoryList(),
    getSalaryGrade(),
  ]).finally(() => {
    loader.value = false
  })

  formData.value.application_deadline =  new Date().toISOString().split('T')[0]
  if (route.query.is_approval && route.query.is_approval !== '' && route.query.is_approval !== undefined){
    isApproval.value = route.query.is_approval === 'true';
  }
  if (route.query.is_job_post && route.query.is_job_post !== '' && route.query.is_job_post !== undefined){
    isJobPost.value = route.query.is_job_post === 'true';
  }
  if (isJobPost.value){
    headerTitle.value = "Add Job Post";
  }

  if(route.query.jobRequisitionId && route.query.jobRequisitionId !== '' && route.query.jobRequisitionId !== undefined){
    isCreate.value = false;
    isJobPublish.value = true;
    const req = fetchSingleJobRequisition(route.query.jobRequisitionId, getQuery());
    req.then(res2 => {
      jobRequisitionEditData.value = res2.data;
      setFormData();
    });
  }
}

onMounted(() => {
  onPageReload();
})
</script>